import { render } from "./User.vue?vue&type=template&id=b109d2ac"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=b109d2ac&lang=scss"

import exportComponent from "/Users/user/Desktop/BD/boarddata/templates/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__